module.exports = __webpack_public_path__ + "static/media/mmume_06.39cf8f86.png";